module.exports = __webpack_public_path__ + "static/media/cov_eat_on_sit.29df3971.png";